import Overview from 'src/containers/Overview/Overview';

export default Overview;